(function () {
  'use strict';
  if (window.KoppaDetailedTracking) return;
  var version = '2026-09-19.3';
  var pending = [];
  var lastQuiz = null;
  var specs = [];
  var quizStorage = 'KOPPA_LAST_QUIZ_V1';
  function rememberQuiz(value) {
    lastQuiz = value;
    if (!allowed()) return;
    try { sessionStorage.setItem(quizStorage, JSON.stringify(value)); } catch (_) {}
  }
  function allowed() { return !!(window.KoppaConsent && window.KoppaConsent.analyticsAllowed()); }
  function emit(name, props) {
    if (!allowed()) return;
    props = Object.assign({tracking_schema_version: version, page_path: location.pathname}, props);
    if (window.CupraTrack) window.CupraTrack(name, props);
    else if (pending.length < 100) pending.push({name: name, props: props});
  }
  function drain() {
    if (!allowed()) {
      pending = []; lastQuiz = null;
      // Privacy API loading is not a consent withdrawal. Preserve prior session context until it resolves.
      try {
        if (window.Shopify.customerPrivacy.currentVisitorConsent().analytics === 'no') sessionStorage.removeItem(quizStorage);
      } catch (_) {}
      return;
    }
    if (window.CupraTrack) pending.splice(0).forEach(function (e) { window.CupraTrack(e.name, e.props); });
  }
  window.addEventListener('amplitude:ready', drain);
  window.addEventListener('koppa:consent', function () {
    drain();
    if (!allowed()) specs.forEach(function (s) { reset(s); s.viewed = false; });
    else { specs.forEach(function (s) { scan(s); }); pageViews(); }
  });
  window.KoppaDetailedTracking = {context: function () {
    if (!allowed()) return {};
    if (!lastQuiz) { try { lastQuiz = JSON.parse(sessionStorage.getItem(quizStorage)); } catch (_) {} }
    if (!lastQuiz || !lastQuiz.id || !lastQuiz.attempt || !lastQuiz.at || Date.now() - lastQuiz.at > 1800000) return {};
    return Object.assign({last_quiz_id: lastQuiz.id, last_quiz_attempt_id: lastQuiz.attempt, last_quiz_completed: lastQuiz.completed}, lastQuiz.shared || {});
  }};
  function reset(s) { s.attempt = null; s.question = null; s.completed = false; s.answerSignatures = {}; }
  function props(s) { return {quiz_id: s.id, quiz_version: version, quiz_attempt_id: s.attempt,
    question_count: s.panels.length, elapsed_seconds: Math.round((Date.now() - s.startedAt) / 1000)}; }
  function start(s) {
    if (!allowed()) return false;
    if (!s.viewed) { s.viewed = true; emit('Quiz Viewed', {quiz_id:s.id,quiz_version:version,question_count:s.panels.length}); }
    if (!s.attempt) {
      s.attempt = crypto.randomUUID(); s.startedAt = Date.now();
      rememberQuiz({id: s.id, attempt: s.attempt, at: Date.now(), completed: false});
      emit('Quiz Started', props(s));
    }
    return true;
  }
  function visible(el) { return !!(el && !el.hidden && el.getClientRects().length); }
  function scan(s) {
    if (!allowed() || !s.attempt) return;
    var panel = s.panels.find(function (p) { return p.classList.contains('is-active') && visible(p); });
    if (panel) {
      var number = s.panels.indexOf(panel) + 1;
      if (s.question !== number) { s.question = number; emit('Quiz Question Viewed', Object.assign(props(s), {question_number: number})); }
    }
    if (s.result && s.result.classList.contains('is-active') && visible(s.result) && !s.completed) {
      s.completed = true;
      var keys = s.keys || (s.root.match && s.root.match.keys) || (s.id === 'find_routine' && window.fyrMatch && window.fyrMatch.keys) || [];
      var shared = {koppa_quiz_completed:true, koppa_quiz_completed_at:new Date().toISOString(),
        koppa_quiz_serum:keys.indexOf('signal') !== -1, koppa_quiz_cream:keys.indexOf('refine') !== -1,
        koppa_quiz_balm:keys.indexOf('precision') !== -1, koppa_quiz_protocol_size:keys.length};
      rememberQuiz({id:s.id, attempt:s.attempt, at:Date.now(), completed:true, shared:shared});
      var completedProps = Object.assign(props(s), shared, {recommended_product_keys: keys});
      emit('Quiz Completed', completedProps);
      if (s.id === 'mens') emit('Men Form Submitted', Object.assign({}, completedProps, {
        form_id:s.root.id || 'mens_quiz', form_attempt_id:s.attempt,
        form_type:'quiz', confirmation_source:'quiz_result_rendered'
      }));
      if (window.KoppaAnalyticsIdentity) window.KoppaAnalyticsIdentity.sync();
    }
  }
  function answer(s, panel, skipped) {
    if (!panel || panel.classList.contains('is-leaving') || !start(s)) return;
    var choices = Array.from(panel.querySelectorAll(s.optionSelector + ':not([data-select-all])'));
    var selected = choices.filter(function (o) { return o.classList.contains('is-selected'); });
    if (!skipped && !selected.length) return;
    var number = s.panels.indexOf(panel) + 1;
    var ids = skipped ? [] : selected.map(function (o) { return 'q' + number + '_a' + (choices.indexOf(o) + 1); });
    var signature = JSON.stringify(ids) + skipped;
    if (s.answerSignatures[number] === signature) return;
    s.answerSignatures[number] = signature;
    emit(skipped ? 'Quiz Question Skipped' : 'Quiz Question Answered', Object.assign(props(s), {question_number:number, answer_ids:ids, answer_count:ids.length}));
  }
  function observeQuiz(s) {
    s.panels = Array.from(s.root.querySelectorAll(s.panelSelector)); reset(s); specs.push(s);
    var host = s.id === 'find_routine' ? s.root.closest('.shopify-section') || s.root.parentElement : s.root;
    new MutationObserver(function () { scan(s); }).observe(host, {subtree:true, attributes:true, attributeFilter:['class','hidden']});
    var viewed = new IntersectionObserver(function (entries) {
      if (!s.viewed && entries.some(function (e) { return e.isIntersecting; }) && allowed()) {
        s.viewed = true; emit('Quiz Viewed', {quiz_id:s.id,quiz_version:version,question_count:s.panels.length});
      }
    }, {threshold:0.2});
    viewed.observe(s.root);
  }
  var planViewSent = false, collectionViewSent = false;
  function pageViews() {
    if (!allowed()) return;
    var planIds = Array.from(document.querySelectorAll('[data-selling-plan-id],[name="selling_plan"]')).map(function (el) { return el.dataset.sellingPlanId || el.value; }).filter(Boolean);
    if (planIds.length && !planViewSent) { planViewSent = true; emit('Purchase Plan Viewed', {selling_plan_ids:Array.from(new Set(planIds)),product_id:window.CupraAnalytics && window.CupraAnalytics.product && window.CupraAnalytics.product.product_id}); }
    if (window.CupraAnalytics && window.CupraAnalytics.pageType === 'collection' && window.CupraAnalytics.collection && !collectionViewSent) { collectionViewSent = true; emit('Collection Viewed', {collection_id:window.CupraAnalytics.collection.collection_id,collection_name:window.CupraAnalytics.collection.collection_name,product_count:window.CupraAnalytics.collection.product_count}); }
  }
  function boot() {
    var home = document.getElementById('ch-quiz');
    if (home) observeQuiz({id:'homepage',root:home,panelSelector:'.ch-quiz__step',optionSelector:'.ch-quiz__opt',result:home.querySelector('.ch-quiz__result')});
    var routine = document.getElementById('fyr-quiz');
    if (routine) observeQuiz({id:'find_routine',root:routine,panelSelector:'.fyr-question',optionSelector:'.fyr-answer',result:document.getElementById('fyr-result')});
    document.querySelectorAll('koppa-men-quiz').forEach(function (root) { observeQuiz({id:'mens',root:root,panelSelector:'.ch-quiz__step',optionSelector:'[data-opt]',result:root.querySelector('.ch-quiz__result')}); });
    document.addEventListener('koppa:quiz-result', function (event) {
      var s = specs.find(function (q) { return q.root === event.target; });
      if (s) { s.keys = event.detail.keys || []; if (start(s)) scan(s); }
    });
    document.addEventListener('click', function (event) {
      var target = event.target.closest('button,a'); if (!target || target.disabled || !allowed()) return;
      var s = specs.find(function (q) { return q.root.contains(target) || (q.result && q.result.contains(target)) || (q.id === 'find_routine' && target.id === 'fyr-start'); });
      if (s) {
        if (target.matches('#ch-quiz-restart,.ch-quiz__restart,.fyr-retake button')) {
          if (s.attempt) emit('Quiz Restarted', props(s)); reset(s); start(s);
        } else if (target.matches('#fyr-start,[data-quiz-start],.ch-quiz__opt,.fyr-answer,[data-opt],.ch-quiz__next,.fyr-next,#fyr-skip')) {
          start(s); scan(s);
          if (target.matches('.ch-quiz__next,.fyr-next,#fyr-skip')) answer(s, target.closest(s.panelSelector) || s.root.querySelector('.fyr-question.is-active'), target.id === 'fyr-skip');
        }
        if (s.completed && target.matches('#ch-qres-link,#fyr-add-routine,[data-quiz-add]')) emit('Quiz Result CTA Clicked', Object.assign(props(s), {action:'add_recommended_products'}));
        else if (s.completed && target.matches('a[href*="/products/"]')) emit('Quiz Recommendation Clicked', Object.assign(props(s), {product_path:new URL(target.href,location.href).pathname}));
        setTimeout(function () { scan(s); }, 0);
      }
      if (target.matches('[data-plan]')) {
        var plan = target.dataset.sellingPlanId || '';
        emit('Purchase Plan Selected', {purchase_type:plan ? 'subscription' : 'one_time', selling_plan_id:plan || undefined, product_id:window.CupraAnalytics && window.CupraAnalytics.product && window.CupraAnalytics.product.product_id});
      }
    }, true);
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (input.matches('[name="selling_plan"]') && (!input.matches('[type="radio"]') || input.checked)) {
        emit('Purchase Plan Selected', {purchase_type:input.value ? 'subscription' : 'one_time',selling_plan_id:input.value || undefined,product_id:window.CupraAnalytics && window.CupraAnalytics.product && window.CupraAnalytics.product.product_id});
      }
    });
    pageViews();
    drain();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
